(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["d_featured-collection-tabbed"] && !Shopify.designMode) return;
  try {
    
    if (!customElements.get('tds-collection-tabs')) {
        customElements.define('tds-collection-tabs', class extends HTMLElement {
            connectedCallback() {
                if (this.initialized) return;
                this.initialized = true;
                const labels = Array.from(this.querySelectorAll('label[data-element="tab-nav"]'));
                if (!labels.length) return;
                labels[0].parentElement.setAttribute('role', 'tablist');
                const tabs = labels.map((label) => {
                    const tab = document.createElement('span');
                    tab.className = 'tds-collection-tab';
                    label.before(tab);
                    tab.append(label);
                    return tab;
                });
                const activate = (selected) => {
                    tabs.forEach((tab) => {
                        const active = tab === selected;
                        tab.tabIndex = active ? 0 : -1;
                        tab.setAttribute('aria-selected', String(active));
                    });
                };
                labels.forEach((label, index) => {
                    const tab = tabs[index];
                    const input = document.getElementById(label.htmlFor);
                    const panel = input?.nextElementSibling;
                    if (!input || !panel) return;
                    tab.id = `${input.id}-tab`;
                    panel.id = `${input.id}-panel`;
                    tab.setAttribute('role', 'tab');
                    tab.setAttribute('aria-controls', panel.id);
                    panel.setAttribute('role', 'tabpanel');
                    panel.setAttribute('aria-labelledby', tab.id);
                    label.addEventListener('click', () => activate(tab));
                    tab.addEventListener('click', (event) => {
                        if (event.target === tab) label.click();
                    });
                    input.addEventListener('change', () => {
                        if (input.checked) activate(tab);
                    });
                    tab.addEventListener('keydown', (event) => {
                        let next = index;
                        if (event.key === 'ArrowRight') next = (index + 1) % labels.length;
                        else if (event.key === 'ArrowLeft') next = (index - 1 + labels.length) % labels.length;
                        else if (event.key === 'Home') next = 0;
                        else if (event.key === 'End') next = labels.length - 1;
                        else if (event.key !== 'Enter' && event.key !== ' ') return;
                        event.preventDefault();
                        labels[next].click();
                        tabs[next].focus();
                    });
                });
                activate(tabs[labels.findIndex((label) => document.getElementById(label.htmlFor)?.checked)] || tabs[0]);
            }
        });
    }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["g_footer"]) return;
  try {
    
if (!customElements.get('tds-footer-groups')) {
  customElements.define('tds-footer-groups', class extends HTMLElement {
    connectedCallback() {
      this.media = window.matchMedia('(max-width: 767px)');
      this.sync = () => {
        this.querySelectorAll('[data-footer-group]').forEach(group => {
          const button = group.querySelector('[data-footer-toggle]');
          if (!button) return;
          const mobile = this.media.matches;
          button.hidden = !mobile;
          group.querySelector('[data-footer-label]').hidden = mobile;
          group.querySelector('[data-footer-panel]').hidden = mobile;
          button.setAttribute('aria-expanded', String(!mobile));
          button.querySelector('span').textContent = mobile ? '+' : '−';
        });
      };
      this.onClick = event => {
        const button = event.target.closest('[data-footer-toggle]');
        if (!button || !this.contains(button)) return;
        const expanded = button.getAttribute('aria-expanded') === 'true';
        button.setAttribute('aria-expanded', String(!expanded));
        button.querySelector('span').textContent = expanded ? '+' : '−';
        button.closest('[data-footer-group]').querySelector('[data-footer-panel]').hidden = expanded;
      };
      this.addEventListener('click', this.onClick);
      this.media.addEventListener('change', this.sync);
      this.sync();
    }
    disconnectedCallback() {
      this.removeEventListener('click', this.onClick);
      this.media.removeEventListener('change', this.sync);
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["g_password-footer"]) return;
  try {
    
    const pwdFooter = document.querySelector('[data-password-footer]');
    document.documentElement.style.setProperty('--password-footer-height', `${pwdFooter.offsetHeight}px`);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["g_password-header"]) return;
  try {
    
    const pwdHeader = document.querySelector('[data-password-header]');
    document.documentElement.style.setProperty('--password-header-height', `${pwdHeader.offsetHeight}px`);

  } catch(e) { console.error(e); }
})();
})();
